import * as React from 'react';
import TailwindModal from '../Tailwind/TailwindModal';
import TailwindButton from '../Tailwind/TailwindButton';

export default function DeleteModal({ item, removeElemFromTree, reloadState, recreateExcelInputIfSync, currentState, patchTree = undefined, setSelected = undefined as any }) {

    const handleClose = () => {
        item.deleteModalOpen = false;
        reloadState();
    }

    const handleDelete = () => {
      if (setSelected) setSelected(null);
      removeElemFromTree(item.id, currentState, reloadState, recreateExcelInputIfSync, patchTree)
      currentState.isComputed = false;
    }

    return (
        <TailwindModal
            isOpen={item.deleteModalOpen}
            onClose={handleClose}
            title="Are you sure?"
            size="md"
            footer={
                <div className="flex gap-3 justify-center w-full">
                    <TailwindButton
                        variant="secondary"
                        onClick={handleClose}
                        icon="close"
                    >
                        Cancel
                    </TailwindButton>
                    <TailwindButton
                        variant="danger"
                        onClick={handleDelete}
                        icon="delete_forever"
                    >
                        Yes, Delete
                    </TailwindButton>
                </div>
            }
        >
            <p className="text-center text-slate-700">
                This will delete <strong>{item.name}</strong> and all its content.
            </p>
        </TailwindModal>
    );
  }
